import React from 'react';
import { Column, Row } from 'react-foundation';

/**
 * A component that shows an organization in card form, for the opportunities tab
 * @param orgID the organization ID
 * @param opportunityData the organization data
 */
export const OpportunityCard = ({ orgID, opportunityData }) => {
	/**
	 * Redirects the user to the opportunity selected
	 */
	const redirectToOpportunity = () => {
		location.assign(
			`/organizations/${orgID}/property_info/opportunities/${opportunityData.id}`
		);
	};

	return (
		<div className="opportunities-card" onClick={redirectToOpportunity}>
			<Row>
				<Column small={14} medium={7}>
					{opportunityData.name ? (
						<h6 className="header-font">{opportunityData.name}</h6>
					) : (
						''
					)}
					{opportunityData.timeframe_start_on ? (
						<p className="body-font org-property-label">
							{opportunityData.timeframe_start_on} to{' '}
							{opportunityData.timeframe_end_on}
						</p>
					) : (
						''
					)}
					{opportunityData.expected_audience ? (
						<p className="body-font org-property-label">
							<strong>Audience reach:</strong>{' '}
							{opportunityData.expected_audience}
						</p>
					) : (
						''
					)}
					{opportunityData.primary_age_group ? (
						<p className="body-font org-property-label">
							<strong>Primary age of attendees:</strong>{' '}
							{opportunityData.primary_age_group}
						</p>
					) : (
						''
					)}
					{opportunityData.genders ? (
						<p className="body-font org-property-label">
							<strong>Primary gender of attendees:</strong>{' '}
							{opportunityData.genders}
						</p>
					) : (
						''
					)}
					{opportunityData.household_income ? (
						<p className="body-font org-property-label">
							<strong>Avg annual household income:</strong>{' '}
							{opportunityData.household_income}
						</p>
					) : (
						''
					)}
				</Column>
				<Column small={12} medium={5} className="picture-column">
					{opportunityData.assets[0] ? (
						<img
							src={opportunityData.assets[0]}
							alt="Header media"
						/>
					) : (
						''
					)}
				</Column>
			</Row>

			<Row>
				<Column className="description-container">
					{opportunityData.description ? (
						<p className="body-font">
							{opportunityData.description.substr(0, 500) + '...'}
						</p>
					) : (
						''
					)}
				</Column>
			</Row>
		</div>
	);
};
